import {
  CoreEditor,
  EditorState,
  getUnconfirmed,
  Node,
  Transform,
} from "@vericus/cadmus-editor-prosemirror";

/**
 * Returns the ProseMirror document node with the unconfirmed steps inverted (if
 * any) back to the last confirmed doc version.
 *
 * Raises an error if the inverstion failed during transformation.
 */
export function confirmedDoc(editor: CoreEditor, state: EditorState): Node {
  const unconfirmed = getUnconfirmed(editor, state);
  if (!Array.isArray(unconfirmed) || unconfirmed.length === 0) return state.doc;

  const transform = new Transform(state.doc);
  // Backwards: undo the newest step first.
  for (let i = unconfirmed.length - 1; i >= 0; i--) {
    const entry = unconfirmed[i];
    if (entry === undefined) {
      throw new Error("ProseMirror unconfirmed buffer index out of bounds");
    }
    // maybeStep moves the transform's doc in place.
    // https://prosemirror.net/docs/ref/#transform.Transform.maybeStep
    const failed = transform.maybeStep(entry.inverted).failed;
    if (failed !== null) {
      throw new Error(failed);
    }
  }

  return transform.doc;
}
